
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rakuten-alternative",
      function () {
        return require("private-next-pages/rakuten-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rakuten-alternative"])
      });
    }
  